import React from "react";
import { useIntl } from "react-intl";

import IDHFormattedMessage from "src/app/components/IDHFormattedMessage/IDHFormattedMessage";
import { MaterialTooltip } from "src/app/components/MaterialTooltip/MaterialTooltip";
import CustomSelect from "src/app/components/CustomSelect/CustomSelect";

export default function SocialPlatformSelect({
  selectedPlatform,
  platforms,
  onPlatformChange,
  isDisabled,
}) {
  const intl = useIntl();
  return (
    <div className="audience-search__field" data-filter-name="social_provider">
      <div className="idh-label idh-label--with-tooltip">
        <IDHFormattedMessage
          id="front_social_platform"
          defaultMessage="Social platform"
        />
        <MaterialTooltip
          id="front_influencer_social_provider_tooltip_1"
          content={
            <>
              <span className="audience-search__tooltip--white-bold">
                <IDHFormattedMessage
                  id="front_influencer_social_provider_tooltip_1"
                  defaultMessage="Here you can select the platform on which you want to search for creators."
                />
              </span>
              <br />
              <br />
              <div>
                <span className="audience-search__tooltip--bold">
                  <IDHFormattedMessage
                    id="front_influencer_social_provider_tooltip_2"
                    defaultMessage="Important: "
                  />
                </span>
                <IDHFormattedMessage
                  id="front_influencer_social_provider_tooltip_3"
                  defaultMessage="Once you create the list, you will not be able to change the selected platform for it."
                />
              </div>
            </>
          }
        />
      </div>
      <CustomSelect
        placeholder={intl.formatMessage({
          id: "front_select_social_platform",
          defaultMessage: "Select social platform",
        })}
        value={selectedPlatform}
        options={platforms}
        onChange={onPlatformChange}
        isDisabled={isDisabled}
        dataAttr="social-platform"
      />
    </div>
  );
}
